import React, { useEffect, useState } from 'react';
// import { HashLink as Link } from 'react-router-hash-link';
import { Card, CardBody, CardHeader, CardText, CardTitle, Col, Container, Row } from 'reactstrap';
// import { OurServicesAtAGlanceData } from '../../common';
import { Link } from 'react-router-dom';
import * as Icons from '../../common/icons/ourServicesAtAGlanceDataIcons';
import axios from 'axios';

const OurServicesAtAGlance = () => {
    const [OurServicesAtAGlanceData, setData] = useState([]);

    const getAllOurServicesAtAGlanceData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/OurServicesAtAGlanceData.json');
            setData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }

    useEffect(() => {
        getAllOurServicesAtAGlanceData();
    }, [])

    return (
        <div className="our-services-at-a-glance">
            <Container className="static-container">
                <h2 className='page-title mb-4'>{OurServicesAtAGlanceData?.pageHeading}</h2>
                <Row className='pt-5'>
                    {OurServicesAtAGlanceData?.glance?.map((item) => {
                        const Icon = Icons[item?.userImg] || null;
                        return (
                            <Col key={item?.id} lg="4" md="4" className="align-self-start">
                                <Link to={`/${item?.link}`} >
                                    <Card className='mb-3 card-one'>
                                        <CardBody className='p-0'>
                                            <div className='d-flex flex-column gap-4 '>
                                                <div>
                                                    <CardHeader className='border-0 p-0'>
                                                        {Icon && <Icon />}
                                                    </CardHeader>
                                                </div>
                                                <div>
                                                    <CardTitle>{item?.title}</CardTitle>
                                                    <CardText>{item?.text}</CardText>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Link>
                            </Col>
                        )
                    }
                    )}
                </Row>
            </Container>
        </div>
    );
}

export default OurServicesAtAGlance;
